// extracted by mini-css-extract-plugin
module.exports = {"block":"footer_block__eekH5","social":"footer_social__30Ek-","link":"footer_link__1g_mS","copyright":"footer_copyright__2-1Mi","contacts":"footer_contacts__oXq_y"};